var $ = require('jquery');

var self = {};

self.initialise = function() {
  const $stepNumber = $('.js-step-number');
  const $backBtn = $('.js-get-quote-back-btn');
  const $nextBtn = $('.js-get-quote-next-btn');
  const $step1 = $('.js-step-1');
  const $step2 = $('.js-step-2');
  const $submitBtn = $('.js-get-quote-submit-btn');

  function initForm() {
    $backBtn.on('click', e => {
      $stepNumber.text(1);
      $step1.show();
      $step2.hide();
    });
    $nextBtn.on('click', e => {
      $stepNumber.text(2);
      $step1.hide();
      $step2.show();
      ga('send', 'event', { eventCategory: 'Get A Quote Form', eventAction: 'Get A Quote Form Submit (S1)', eventLabel: 'Get A Quote Form Submit (S1)'});
    });
    $submitBtn.on('click', e => {
      ga('send', 'event', 'Quote Request Form Submit', 'Quote Request Form Submit', 'Quote Request Form Submit', 'Value');
    });
  }

  initForm();
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/rebuild-components/init-get-a-quote.js